import {RouteDefinition} from "../../../routes"
import {AdvancedMenu} from "./AdvancedMenu"
import {AdvancedPanelSettings} from "./PanelSettings"
import {SupervisorConfigScreen} from "./SupervisorConfigEditScreen"
import {BrightnessTestScreen} from "./Test/Brightness"
import {ColorTestScreen} from "./Test/Color"
import {NetworkTestMenuScreen} from "./Test/Network/NetworkMenu"
import {PingTestScreen} from "./Test/Network/Ping"
import {SpeedTestScreen} from "./Test/Network/SpeedTest"
import {TraceRootTestScreen} from "./Test/Network/TraceRoot"
import {SoundTestScreen} from "./Test/Sound"
import {SystemInfoTestScreen} from "./Test/SystemInfo"
import {TestMenuScreen} from "./Test/TestMenu"
import {TouchTestScreen} from "./Test/Touch"
import {WorkerConfigScreen} from "./WorkerConfigEditScreen"
export const AdvancedMenuSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: "/settings/advanced-settings",
        component: AdvancedMenu
    },
    {
        routerLink: "/settings/advanced-settings/supervisor-config",
        component: SupervisorConfigScreen
    },
    {
        routerLink: "/settings/advanced-settings/worker-config",
        component: WorkerConfigScreen
    },
    {
        routerLink: "/settings/advanced-settings/test",
        component: TestMenuScreen
    },
    {
        routerLink: "/settings/advanced-settings/test/color-test",
        component: ColorTestScreen
    },
    {
        routerLink: "/settings/advanced-settings/test/touch-test",
        component: TouchTestScreen
    },
    {
        routerLink: "/settings/advanced-settings/test/sound-test",
        component: SoundTestScreen
    },
    {
        routerLink: "/settings/advanced-settings/test/brightness-test",
        component: BrightnessTestScreen
    },
    {
        routerLink: "/settings/advanced-settings/test/system-info",
        component: SystemInfoTestScreen
    },
    {
        routerLink: "/settings/advanced-settings/test/network",
        component: NetworkTestMenuScreen
    },
    {
        routerLink: "/settings/advanced-settings/test/network/ping-test",
        component: PingTestScreen
    },
    {
        routerLink: "/settings/advanced-settings/test/network/trace-root-test",
        component: TraceRootTestScreen
    },
    {
        routerLink: "/settings/advanced-settings/test/network/speed-test",
        component: SpeedTestScreen
    },
    {
        routerLink: "/settings/advanced-settings/panel-settings",
        component: AdvancedPanelSettings
    }
]
